import { jsx } from 'react/jsx-runtime';
import { styled } from 'styled-components';
import { Flex } from '@fabric-app/ui/components/Flex';
import { cssVar } from '@fabric-app/ui/theme/variables';
import { ExtraPanelSidebar } from '../../resource-detail/components/ExpandedResource/ExtraPanel/Sidebar.js';
import { IconSidePanelFullScreen } from '@fabric-app/icons/svg';

const AssistantInnerHeader = styled(Flex).attrs((p) => {
  return {
    justifyContent: "space-between",
    alignItems: "center",
    ...p
  };
}).withConfig({
  displayName: "AssistantHeader__AssistantInnerHeader",
  componentId: "sc-bbbac092-0"
})([
  `width:100%;max-width:800px;margin:0 auto;`
]);
const AssistantHeaderRoot = styled(Flex).attrs((p) => {
  return {
    justifyContent: "space-between",
    alignItems: "center",
    ...p,
    children: /* @__PURE__ */ jsx(AssistantInnerHeader, {
      children: p.children
    })
  };
}).withConfig({
  displayName: "AssistantHeader__AssistantHeaderRoot",
  componentId: "sc-bbbac092-1"
})([
  `flex-shrink:0;padding:0.75rem;border-bottom:1px solid rgba(`,
  `,0.1);`
], cssVar["color-bg-contrast-reverse-rgb"]);
const AssistantHeaderLeft = styled(Flex).attrs((p) => {
  return {
    alignItems: "center",
    ...p
  };
}).withConfig({
  displayName: "AssistantHeader__AssistantHeaderLeft",
  componentId: "sc-bbbac092-2"
})([
  `gap:0.375rem;`
]);
const AssistantHeaderRight = styled(Flex).attrs((p) => {
  return {
    alignItems: "center",
    justifyContent: "flex-end",
    ...p
  };
}).withConfig({
  displayName: "AssistantHeader__AssistantHeaderRight",
  componentId: "sc-bbbac092-3"
})([
  `gap:0.625rem;`
]);
const Root = AssistantHeaderRoot;
const Left = AssistantHeaderLeft;
const AssistantButton = ExtraPanelSidebar.Button;
const FullScreenButton = styled(AssistantButton).attrs((p) => {
  return {
    ...p,
    children: /* @__PURE__ */ jsx(IconSidePanelFullScreen, {})
  };
}).withConfig({
  displayName: "AssistantHeader__FullScreenButton",
  componentId: "sc-bbbac092-4"
})([
  ``
]);
const AssistantHeader = {
  Root,
  Left,
  Right: AssistantHeaderRight,
  FullScreenButton
};

export { AssistantHeader, AssistantHeaderLeft, AssistantHeaderRoot, FullScreenButton, Left, Root };
//# sourceMappingURL=AssistantHeader.js.map
